import { render, staticRenderFns } from "./basic-title.vue?vue&type=template&id=09f04909&scoped=true"
import script from "./basic-title.vue?vue&type=script&lang=ts"
export * from "./basic-title.vue?vue&type=script&lang=ts"
import style0 from "./basic-title.vue?vue&type=style&index=0&id=09f04909&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f04909",
  null
  
)

export default component.exports